import React from "react";
import { MobileProgressStep } from "./_/MobileProgressStep";
import { ProgressSteps } from "../../types/ProgressSteps";

export const MobileProgressBar: React.FC<ProgressSteps> = ({ ...props }) => {
  return <MobileProgressStep {...props} />;
};
